import { sortBy } from "lodash-es";

import type { DictsysPhrase, DictsysPhraseReference } from "@/types";

export type DictsysPhraseTargetType = "translation" | "example";

export interface DictsysPhraseTarget {
  text: string;
  references: DictsysPhraseReference[];
}

export interface DictsysPhraseGroup extends DictsysPhraseType {
  phrase: string;
}

interface DictsysPhraseType {
  translations: DictsysPhraseTarget[];
  examples: DictsysPhraseTarget[];
}

export function getCommonReferences(phrases: DictsysPhrase[]): DictsysPhraseReference[] {
  return phrases.reduce<DictsysPhraseReference[]>((result, phrase) => {
    if (phrase.references.length === 0 || hasPhraseContent(phrase)) {
      return result;
    }

    return [...result, ...phrase.references];
  }, []);
}

export function getPhraseGroups(phrases: DictsysPhrase[]): DictsysPhraseGroup[] {
  return sortBy(
    phrases.filter(hasPhraseContent).reduce<DictsysPhraseGroup[]>((result, phrase) => {
      const groupIndex = result.findIndex((group) => group.phrase === phrase.source);
      const typeKey: keyof DictsysPhraseType = phrase.target !== "" ? "translations" : "examples";

      const target = {
        text: typeKey === "translations" ? phrase.target : phrase.example,
        references: phrase.references
      };

      if (groupIndex !== -1) {
        result[groupIndex][typeKey].push(target);
      } else {
        const newGroup: DictsysPhraseGroup = {
          phrase: phrase.source,
          translations: [],
          examples: []
        };
        newGroup[typeKey].push(target);
        result.push(newGroup);
      }

      return result;
    }, []),
    "phrase"
  );
}

const hasPhraseContent = (phrase: DictsysPhrase): boolean =>
  phrase.source !== "" || phrase.target !== "" || phrase.example !== "";
